namespace Matrix.Administration {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class UserRoleDialog extends Serenity.TemplatedDialog<UserRoleDialogOptions> {

        private permissions: RoleCheckEditor;

        constructor(opt: UserRoleDialogOptions) {
            super(opt);

            this.permissions = new RoleCheckEditor(this.byId('Roles'));

            UserRoleService.List({
                Username: this.options.username
            }, response => {
                this.permissions.value = response.Entities.map(x => x.toString());
            });
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();

            opt.buttons = [{
                text: Q.text('Dialogs.OkButton'),
                click: () => {
                    Q.serviceRequest('Administration/UserRole/Update', {
                        Username: this.options.username,
                        Roles: this.permissions.value
                    }, response => {
                        this.dialogClose();
                        Q.notifySuccess(Q.text('Site.UserRoleDialog.SaveSuccess'));
                    });
                }
            }, {
                text: Q.text('Dialogs.CancelButton'),
                click: () => this.dialogClose()
            }];

            opt.title = Q.format(Q.text('Site.UserRoleDialog.DialogTitle'), this.options.username);
            return opt;
        }

        protected getTemplate() {
            return "<div id='~_Roles'></div>";
        }
    }

    export interface UserRoleDialogOptions {
        username: string;
    }
}